var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11655_12554)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71073 1.09327C9.37748 0.278806 10.6231 0.278803 11.2899 1.09327L12.1164 2.10282L13.337 1.64179C14.3217 1.26986 15.4003 1.89262 15.5706 2.93138L15.7817 4.21894L17.0692 4.42997C18.108 4.60022 18.7307 5.67887 18.3588 6.6636L17.8977 7.88417L18.9073 8.7107C19.7217 9.37753 19.7217 10.623 18.9073 11.2899L17.8977 12.1164L18.3588 13.3369C18.7307 14.3217 18.108 15.4004 17.0692 15.5706L15.7817 15.7816L15.5707 17.0692C15.4003 18.108 14.3217 18.7307 13.337 18.3588L12.1164 17.8978L11.2899 18.9073C10.6231 19.7218 9.37748 19.7218 8.71073 18.9073L7.88417 17.8978L6.66359 18.3588C5.67887 18.7307 4.60022 18.108 4.42997 17.0692L4.21893 15.7816L2.93138 15.5706C1.89261 15.4004 1.26986 14.3217 1.64179 13.3369L2.10282 12.1164L1.09328 11.2899C0.278806 10.623 0.278802 9.37753 1.09328 8.7107L2.10282 7.88417L1.64179 6.6636C1.26985 5.67887 1.89262 4.60022 2.93138 4.42997L4.21893 4.21894L4.42997 2.93138C4.60022 1.89262 5.67888 1.26986 6.66359 1.64179L7.88417 2.10282L8.71073 1.09327ZM9.3399 13.5062L15.1732 7.67288L13.9947 6.49437L8.75065 11.7385L6.00658 8.99437L4.82806 10.1729L8.16139 13.5062C8.31768 13.6625 8.52965 13.7503 8.75065 13.7503C8.97165 13.7503 9.18365 13.6625 9.3399 13.5062Z",
    fill: "#6AF684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11655_12554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.d9e78a77a985f185f3464f426c88c4ee.svg";
export { ForwardRef as ReactComponent };